// Angular
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
// Local services
import { ClienteService } from '../../services/cliente.service';
// 3rd libraries
import swal from 'sweetalert2';
import { NgxUiLoaderService } from 'ngx-ui-loader';
// Common functions
import { CommonFunctions } from '../../utils/common-functions';

@Component({
  selector: 'app-gestiones-ofertas-precalificacion',
  templateUrl: './gestiones-ofertas-precalificacion.component.html',
  styleUrls: ['./gestiones-ofertas-precalificacion.component.scss']
})
export class GestionesOfertasPrecalificacionComponent implements OnInit {
  // Formatters
  formatterDecimal = new Intl.NumberFormat('es-GT', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: 'decimal',
  });
  // Bindings
  commonFunctions = CommonFunctions;
  listindexactive = [];
  ofertascomercialesaux = [];
  ofertaseleccionada = 0;
  // Decorations
  @Output() selecttab = new EventEmitter<number>();
  @Output() setDataCliente = new EventEmitter<any>();
  @Input() clienteserviceParam: ClienteService;
  constructor(private ngxUiLoaderService: NgxUiLoaderService) {
    setTimeout(() => {
      if (this.clienteserviceParam.datosCliente.needCoDebtor === false && this.clienteserviceParam.datosPrecalificacion.segmento != "PV") {
        this.setPriorizacion();
      }else{
        this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
      }
    }, 500);
  }

  ngOnInit(): void {
  }

  changeindexactive(index) {
    if (this.listindexactive.includes(index)) {
      const aux = this.listindexactive.indexOf(index);
      this.listindexactive.splice(aux, 1);
    } else {
      this.listindexactive.push(index);
    }
  }
  selectOferta(index) {
    this.ofertaseleccionada = index;
  }
  goToSeleccion() {
    this.clienteserviceParam.ofertaseleccionada = this.ofertaseleccionada;
    let flujoMixMatch = false;
    if(this.clienteserviceParam.ofertasComerciales.ofertaComercial[this.ofertaseleccionada].color == "ROJO"){ 
      this.clienteserviceParam.validateOfertaSolicitud()
      this.selecttab.emit(11)
    }else{
      this.selecttab.emit(11);
    }
  }
  showPreguntaMyM() {
    swal.fire({
      title: '',
      text: 'Sabes que el ahorro te permitirá alcanzar tus objetivos de manera más fácil, ¿Te gustaría iniciar con una cultura de Ahorro?',
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      customClass: {
        confirmButton: 'btn button-precas',
        denyButton: 'btn button-precas',
        input: 'inputswt',
        title: 'titleswt'
      },
      showCloseButton: true,
      buttonsStyling: false,
      heightAuto: false,
      showDenyButton: true,
      confirmButtonText: 'Si',
      denyButtonText: 'No',
    }).then(result => {
      if (result.isConfirmed) {
        this.selecttab.emit(13); // comparativa mix and match
      } else if (result.isDenied) {
        this.selecttab.emit(11);
      }
    });
  }
  showNotification(title, message) {
    swal.fire({
      title,
      text: message,
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      customClass: {
        confirmButton: 'btn button-precas',
        input: 'inputswt',
        title: 'titleswt'
      },
      showCloseButton: true,
      buttonsStyling: false,
      heightAuto: false,
      confirmButtonText: 'Continuar'
    }).then(result => {
      this.selecttab.emit(0);
    });
  }
  goBack() {
    if(this.clienteserviceParam.datosPrecalificacion.segmento=="PV" &&!this.clienteserviceParam.rolABFlag){
      this.clienteserviceParam.commonCredits = [];
      this.clienteserviceParam.datosPrecalificacionCodeudor = {};
      this.clienteserviceParam.rejectCoDebtorFlow().then(() => {
        this.selecttab.emit(10);
      });
    }else if(this.clienteserviceParam.rolABFlag){
      this.clienteserviceParam.ofertaseleccionada =null
      this.selecttab.emit(20);//pantalla monto y plazo ab
    }
    else{
      this.clienteserviceParam.ofertaseleccionada =null
      this.selecttab.emit(10); // volver a monto y plazo
    }
  }
  setPriorizacion() {
    if (this.clienteserviceParam.ofertaseleccionada == null) {
      this.ofertascomercialesaux = this.clienteserviceParam.ofertasComerciales.ofertaComercial.sort(
        (a, b) => a.grupoNumeroOfertaJerarquia - b.grupoNumeroOfertaJerarquia,
      );
    }
    if (this.clienteserviceParam.ofertaseleccionada != null) {
      this.ofertaseleccionada = this.clienteserviceParam.ofertaseleccionada;
    } else if (this.clienteserviceParam.bienestarSFM > 0 && this.clienteserviceParam.mixAndMachMontoAhorro === 0) {
      this.clienteserviceParam.ofertasComerciales.ofertaComercial = this.ofertascomercialesaux.slice(1, 7);
    } else if (this.clienteserviceParam.bienestarSFM > 0 && this.clienteserviceParam.mixAndMachMontoAhorro > 0) {
      this.ofertaseleccionada = this.clienteserviceParam.ofertasComerciales.ofertaComercial.findIndex(
        item => item.grupoNumeroOferta === this.clienteserviceParam.ofertamym
          && item.bienestarMixAndMatchFlg === '1',
      );
    } else {
      this.clienteserviceParam.ofertasComerciales.ofertaComercial = this.ofertascomercialesaux.slice(1, 4);
    }
    this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
  }

  getcuotamym(oferta) {
    return Number(oferta.cuotaNuevoCreditoConSeguro - Number(oferta.bienestarMixAndMatchAhorroMensual));
  }

  finishDebtorFlow() {
    if(this.clienteserviceParam.datosPrecalificacion.segmento!='PV'){
      this.ngxUiLoaderService.startLoader('loader-global', 'loadingDashboard');
      this.clienteserviceParam.commonCredits = [];
      this.clienteserviceParam.datosPrecalificacionCodeudor = {};
      this.clienteserviceParam.rejectCoDebtorFlow().then(() => {
        this.ngxUiLoaderService.startLoader('loader-global', 'loadingDashboard');
        this.selecttab.emit(11);
      });
    }else{
      this.ngxUiLoaderService.startLoader("loader-global", "loadingDashboard");
        this.clienteserviceParam
        .solicitarOferta()
        .then((result) => {
          this.ngxUiLoaderService.stopLoader(
            "loader-global",
            "loadingDashboard"
          );
          this.clienteserviceParam.datosCliente.needCoDebtor = false;
          if (result == "SD") {
            this.showNotificationsinoferta(
              "No se han obtenido ofertas",
              "Por el momento el cliente no tiene ofertas disponibles."
            );
          } else if (result == "A") {
            if (this.clienteserviceParam.ofertasComerciales.ofertaComercial.length == 2 && this.clienteserviceParam.ofertasComerciales.ofertaComercial[0].bienestarMixAndMatchFlg==1) {
              this.clienteserviceParam.ofertaseleccionada = 0
              this.clienteserviceParam.ofertamym=0
              this.selecttab.emit(13)
            } else {
              this.selecttab.emit(12)
            }
          } else {
            this.showNotificationsinoferta(
              "Ha ocurrido un error",
              "Por el momento el cliente no tiene ofertas disponibles."
            );
          }
        })
        .catch((error) => {
          this.ngxUiLoaderService.stopLoader(
            "loader-global",
            "loadingDashboard"
          );
          if (error.codigoError && error.codigoError == "1003") {
            this.showNotificationsinoferta(
              "Aviso",
              error.mensajeTecnicoAPI
            );
          }
          else if (error.codigoError!="0") {
            this.showNotificationError(
              "Aviso",
              'Ha ocurrido un error, intentelo más tarde. Código de error: '+error.codigoError
            );
          }
          else if (error == "errorguardado") {
            this.showNotificationsinoferta(
              "Ha ocurrido un error",
              "No se ha podido guardar la precalificación."
            );
          } else{
            this.showNotificationError(
              "Alerta",
              "No se ha podido establecer conexión con el servidor, intentelo de nuevo."
            );
          }
        });

    }
  }

  showDpiAlert() {
    const dpi = '';
    swal.fire({
      title: 'Ingrese el DPI del codeudor',
      input: 'text',
      inputLabel: 'DPI',
      inputValue: dpi,
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      showCloseButton: true,
      allowOutsideClick: false,
      buttonsStyling: false,
      heightAuto: false,
      inputValidator: result => !result && 'Por favor ingrese un número de DPI.'
        || result.length !== 13 && 'El número de DPI no es válido, favor verifique.'
        || result === this.clienteserviceParam.datosCliente.cliente.dpi && 'El número de DPI ingresado no puede ser igual al de deudor',
      customClass: {
        confirmButton: 'btn button-precas',
        input: 'inputswt',
        title: 'titleswt'
      },
      confirmButtonText: 'Continuar',
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.clienteserviceParam.commonCredits = [];
        this.clienteserviceParam.datosPrecalificacionCodeudor = {};
        this.clienteserviceParam.datosCodeudor = {};
        this.clienteserviceParam.isLoadIndex = false;
        this.clienteserviceParam.manualEntry = false;
        this.ngxUiLoaderService.startLoader('loader-global', 'loadingDashboard');
        this.setDataCliente.emit({
          dpi: result.value,
          flowType: 'CODEBTOR',
        });
      }
    });
  }
  showNotificationsinoferta(title, message) {
    swal
      .fire({
        title: title,
        text: message,
        confirmButtonColor: "#fff",
        background: "#eeedf2",
        customClass: {
          confirmButton: "btn button-precas",
          input: "inputswt",
          title: "titleswt",
        },
        showCloseButton: true,
        buttonsStyling: false,
        heightAuto: false,
        confirmButtonText: "Continuar",
      })
      .then((result) => {
        this.selecttab.emit(0);
      });
  }
  showNotificationError(title, message) {
    swal
      .fire({
        title: title,
        text: message,
        confirmButtonColor: "#fff",
        background: "#eeedf2",
        customClass: {
          confirmButton: "btn button-precas",
          input: "inputswt",
          title: "titleswt",
        },
        showCloseButton: true,
        buttonsStyling: false,
        heightAuto: false,
        confirmButtonText: "Continuar",
      })
      .then((result) => {
      });
  }
}
